import cache_version from 'cache_version.json';
import { Urls } from 'interfaces/urls.interface';

export const urls: Urls = {
  API_HOST_URL: 'https://api.worldwater.io',
  TURNSTILE_SITE_KEY: '0x4AAAAAAEfJHUN9UZXSaQNU',
  TURNSTILE_ACTION: 'waterclock_request_data',
  TURNSTILE_DISABLED: false,
  cacheVersion: cache_version,
};
